import { Component, Input } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { DynamicFormControl } from '../../models/dynamic-form-control.model';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { DYNAMIC_ERROR_STATE_MATCHER } from '../../services/dynamic-control-error-state-matcher';

@Component({
  selector: 'lib-date-picker-control',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './date-picker-control.component.html',
  styleUrl: './date-picker-control.component.scss',
})
export class DatePickerControlComponent {
  @Input() control: DynamicFormControl;

  inputControl: FormControl;
  errorStateMatcher = DYNAMIC_ERROR_STATE_MATCHER;

  isCompletionDate: boolean = false;

  today = new Date();

  /**
   * Drives the Material required-asterisk explicitly instead of relying on
   * Material's implicit validator detection, which fails to render the asterisk
   * for controls that stay empty (e.g. a disabled, pre-populated field) because
   * no `stateChanges` event is emitted to refresh the form field.
   */
  get isRequired(): boolean {
    return (
      this.control?.customOptions?.isRequired ||
      this.inputControl?.hasValidator(Validators.required) ||
      false
    );
  }

  ngOnInit() {
    if (this.control.propertyBinding === 'completionDate') {
      this.isCompletionDate = true;
      this.inputControl = this.control.formControls[0].formControl;
    } else {
      this.inputControl = this.control.formControls[0].formControl;
    }
  }
}
